$(function () {
  $(document).ready(function () {
    const allReviewButtons = document.querySelectorAll(
      '.loading_custom_review'
    );
    if (allReviewButtons && allReviewButtons.length > 0) {
      for (let i = 0; i < allReviewButtons.length; i++) {
        allReviewButtons[i].addEventListener('click', function (e) {
          e.preventDefault();
          document
            .getElementById('tydal-reviews-panel')
            .scrollIntoView({behavior: 'smooth'});
        });
      }
    }
   function thumnails_when_scroll(){
      if (window.innerWidth > 550) {
        return;
      }
      
         var scrollTop =
        (window.pageYOffset || document.scrollTop) -
          (document.clientTop || 0) || 0;

          var title_price = document.querySelector('.wrap_loading_title_price').offsetHeight;
          var header_height = document.querySelector('.section-header-mobile').offsetHeight;
          var header_scroll = document.querySelector('.shopify-section-group-header-group').offsetHeight;
          var thumbnails_height = document.querySelector('.tee-thumbnails').offsetHeight;
          var all_height = parseInt(title_price) + parseInt(header_height) + parseInt(header_scroll);
              if(scrollTop > (all_height -50) ){ 
                var scroll_scale = scrollTop - all_height;
                  scroll_scale +=30;
                  var scale_item = (100 - parseInt(scroll_scale)) / 100;
                  document.querySelectorAll('.tee-thumbnail').forEach((item) => {
                      item.style.transform = 'scale(0)';
                  })
                
              } else{
                    document.querySelectorAll('.tee-thumbnail').forEach((item) => {
                      item.style.transform = 'scale(1)';
                  });
              // document.querySelector('.tee-thumbnails').style.transform = 'scale(1)';
              }
          

   }
    window.addEventListener('scroll', function () {
        thumnails_when_scroll();
      loading_sticky_product();
      
    });
    window.addEventListener('resize', function () {
        thumnails_when_scroll();
      loading_sticky_product();
    });

    function loading_sticky_product() {
      if (window.innerWidth > 550) {
        return;
      }
    
      var product_item_sticky = document.querySelector(
        'div[data-image-gallery=""]'
      );
      var wrap_sticky_item = product_item_sticky.closest(
        '.loading_mobile_custom_title_price'
      );
      var item_till_sticky = wrap_sticky_item.querySelector(
        '.tee-form-atc-wrapper'
      );

      if (!item_till_sticky) {
        item_till_sticky = wrap_sticky_item.querySelector('.addtocart_trusted');
      }
      var sticky_height = product_item_sticky.offsetHeight;
      var wrapitem_height = wrap_sticky_item.offsetHeight;
      var till_sticky_height = item_till_sticky.offsetHeight;

      var scrollTop =
        (window.pageYOffset || document.scrollTop) -
          (document.clientTop || 0) || 0;
      var scroll_sticky_height = parseInt(wrapitem_height - sticky_height);

      var topPos =
        product_item_sticky.getBoundingClientRect().top + window.scrollY;
      var topPostill =
        item_till_sticky.getBoundingClientRect().top + window.scrollY;
      var topPoststillSticky = topPostill - sticky_height;
      topPoststillSticky += 300;
    

      if (document.querySelector('.tee-thumbnails').length > 0) {
        var item_height =
          document.querySelector('.tee-thumbnails').offsetHeight;
        topPos = item_height + topPos + 10;
      }

      if (scrollTop >= topPos) {
        product_item_sticky.classList.add('start_sticky');
        product_item_sticky.classList.add('loading_is_ticky');
        document
          .querySelector('.loading_mobile_custom_title_price')
          .classList.add('wrap_is_sticky');
        window.dispatchEvent(new Event('resize', {bubbles: true}));
      }
 

      if (scrollTop < topPos) {
        product_item_sticky.classList.remove('start_sticky');
        product_item_sticky.classList.remove('loading_is_ticky');
        document
          .querySelector('.loading_mobile_custom_title_price')
          .classList.remove('wrap_is_sticky');
        window.dispatchEvent(new Event('resize', {bubbles: true}));
      }
      if (scrollTop >= topPoststillSticky) {
        var topSpace = topPoststillSticky - scrollTop;
        if (topSpace < 0) {
          product_item_sticky.style.top = topSpace + 'px';
        } else {
          product_item_sticky.style.top = 0;
        }
        product_item_sticky.classList.remove('start_sticky');
        product_item_sticky.classList.add('out_of_sticky');
      }
      if (scrollTop < topPoststillSticky) {
        product_item_sticky.classList.remove('out_of_sticky');
        product_item_sticky.classList.add('start_sticky');
        product_item_sticky.style.top = 0;
      }
    }
  });

  LoadingCustomize = {
    init: function () {
      this.popup_guildline();
    },
    popup_guildline: function () {
      var items_guildline = document.querySelectorAll(
        '.loading_wrap_personalize'
      );
      if (items_guildline && items_guildline.length > 0) {
        for (let i = 0; i < items_guildline.length; i++) {
          items_guildline[i].addEventListener('click', function () {
            document
              .querySelector('.wrap_guidline_popup')
              .classList.add('active');
            document.querySelector('body').classList.add('active_gp');
          });
        }
        document
          .querySelector('.close_popup_guidline')
          .addEventListener('click', function () {
            document
              .querySelector('.wrap_guidline_popup')
              .classList.remove('active');
            document.querySelector('body').classList.remove('active_gp');
          });

        document.addEventListener('click', (event) => {
          setTimeout(() => {
            var cur = event.target;

            var current_item = event.target;
            if (
              event.target.closest('.wrap_guidline_popup') ||
              event.target.closest('.loading_wrap_personalize')
            ) {
            } else {
              if (
                document
                  .querySelector('.wrap_guidline_popup')
                  .classList.contains('active')
              ) {
                document
                  .querySelector('.wrap_guidline_popup')
                  .classList.remove('active');
                document.querySelector('body').classList.remove('active_gp');
              }
            }
          }, 10);
        });
      }
    },
  };
  window.addEventListener('load', function () {
    LoadingCustomize.init();
  });
});
